import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

const ONBOARDING_ALLOWED_PATHS = ["/bienvenue", "/logout"];

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-primary animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Onboarding : rediriger vers /bienvenue si le profil n'a jamais été choisi.
  // On tolère cependant l'accès aux pages listées explicitement.
  const onboardingIncomplete = !user.profile_type_selected_at;
  const isOnboardingRoute = ONBOARDING_ALLOWED_PATHS.some((p) => location.pathname.startsWith(p));
  if (onboardingIncomplete && !isOnboardingRoute) {
    return <Navigate to="/bienvenue" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
